import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const log_user_action = async (action) => {
    if (!action) return { error: "No action provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/analytics/collector/users`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(action),
        credentials: "include"
    });
};

export const fetch_user_analytics = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/analytics/data/users`,
        method: "GET",
        credentials: "include"
    });
};
